<template>
  <div class="row merchant-footer m-0 text-center">
    <div class=" col-lg-6 col-12 copyright">
      <p>&copy; {{ currentYear }} Amej Pay. All Rights Reserved.</p>
    </div>
    <div class=" col-lg-6 col-12 powered-by">
      <router-link :to="{ name: 'pricacyPolicy' }" target="_blank" style="color: #FFF; text-decoration: none; font-size: 14px;">Privacy Policy</router-link> 
      &nbsp; | &nbsp;
      <router-link :to="{ name: 'termAndCondition' }" target="_blank" style="color: #FFF; text-decoration: none; font-size: 14px;">Terms &amp; Conditions</router-link>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      currentYear: new Date().getFullYear(),
    };
  },
};
</script>
<style lang="scss" scoped>
.merchant-footer {
  background-color: #4b4b4b;
  width: 100vw;
  height: 70px;
  display: flex;
  justify-content: space-around;
  align-items: center;
  p {
    color: #fff;
    margin:0px;
  }
}
</style>